<div class="card sensor-container">
    <p-toolbar styleClass="mb-4 sensor-toolbar">
        <ng-template pTemplate="left">
            <button pButton pRipple label="Novo" [disabled]="!direitoInserir"
                icon="pi pi-plus" class="p-button-success mr-2" (click)="openNew()"></button>
        </ng-template>

        <!-- <ng-template pTemplate="right">
            <div class="flex">
                <button type="button" pButton pRipple icon="pi pi-file-excel" (click)="exportExcel()"
                    class="p-button-success mr-2" pTooltip="XLS" tooltipPosition="bottom"></button>
                <button type="button" pButton pRipple icon="pi pi-file-pdf" (click)="exportPdf()"
                    class="p-button-warning mr-2" pTooltip="PDF" tooltipPosition="bottom"></button>
            </div>
        </ng-template> -->
    </p-toolbar>

    <div class="sensor-table-wrapper" #tableWrapper>
        <p-table #dt [value]="data" [rows]="20" styleClass="p-datatable-gridlines p-datatable-responsive-demo"
            [paginator]="true" [rowHover]="true" dataKey="id"
            currentPageReportTemplate="Exibindo {first} a {last} de {totalRecords} registros" [showCurrentPageReport]="true"
            [globalFilterFields]="['id','descricao','cliente.nome', 'estacao.descricao']"
            [scrollable]="true" [scrollHeight]="scrollHeight">


        <ng-template pTemplate="caption">
            <div class="flex p-flex-column p-flex-md-row align-items-center justify-content-between">
                <h5 class="p-m-0">Transmissores</h5>
                <span class="p-input-icon-left mt-2 md:mt-0">
                    <i class="pi pi-search"></i>
                    <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                        placeholder="Pesquisar..." />
                </span>
            </div>

        </ng-template>
        <ng-template pTemplate="header">
            <tr>
                <th style="width: 8%">Código</th>
                <th style="width: 18%">Descrição</th>
                <th style="width: 14%">Identificador</th>
                <th style="width: 18%">Estação</th>
                <th style="width: 16%">Cliente</th>
                <th class="col-acoes" style="width: 14%; min-width: 120px">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dt>
            <tr>
                <td><span class="p-column-title negrito">Código: </span>{{dt.id}}</td>
                <td><span class="p-column-title negrito">Descrição: </span>{{dt.descricao}}</td>
                <td><span class="p-column-title negrito">Identificador: </span>{{dt.identificador}}</td>
                <td><span class="p-column-title negrito">Estação: </span>{{dt.estacao?.descricao}}</td>
                <td><span class="p-column-title negrito">Cliente: </span>{{dt.estacao?.cliente?.nome}}</td>
                <td class="col-acoes" style="text-align: center; white-space: nowrap">
                    <span class="p-column-title negrito">Ações: </span>
                    <button pButton pRipple [disabled]="!direitoEditar"
                        icon="pi pi-pencil" class="p-button-rounded p-button-primary mr-2"
                        pTooltip="Editar" (click)="edit(dt)"></button>
                    <button pButton pRipple [disabled]="!direitoExcluir"
                        icon="pi pi-trash" class="p-button-rounded p-button-danger"
                        pTooltip="Excluir transmissor" (click)="confirmarExclusao(dt)"></button>
                </td>
            </tr>
        </ng-template>

        </p-table>
    </div>
</div>


<p-dialog header="Transmissores" [(visible)]="displayModal" [modal]="true" [breakpoints]="{'960px': '75vw'}"
    [style]="{width: '50vw'}" [baseZIndex]="10000" [draggable]="false" [resizable]="false">
    <div [ngStyle]="{'margin': '7px'}">
        <form [formGroup]="form" class="p-fluid grid">

            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="text" id="descricao" pInputText formControlName="descricao"
                        [class.ng-invalid]="form.get('descricao')?.invalid && form.get('descricao')?.touched">
                    <label for="descricao">Descrição *</label>
                </p-floatlabel>
                <small *ngIf="form.get('descricao')?.invalid && form.get('descricao')?.touched" class="p-error">
                    Descrição é obrigatória.
                </small>
            </div>
            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <p-dropdown inputId="estacao_id" appendTo="body" [filter]="true" filterLocale="pt-BR" [options]="dropDownEstacao"
                        formControlName="estacao_id"
                        [class.ng-invalid]="form.get('estacao_id')?.invalid && form.get('estacao_id')?.touched">
                    </p-dropdown>
                    <label for="estacao">Estação *</label>
                </p-floatlabel>
                <small *ngIf="form.get('estacao_id')?.invalid && form.get('estacao_id')?.touched" class="p-error">
                    Estação é obrigatória.
                </small>
            </div>
            <div class="field col-12 md:col-12 xl:col-12">
                <p-floatlabel>
                    <input type="text" id="identificador" pInputText formControlName="identificador"
                        [class.ng-invalid]="form.get('identificador')?.invalid && form.get('identificador')?.touched">
                    <label for="identificador">Identificador *</label>
                </p-floatlabel>
                <small *ngIf="form.get('identificador')?.invalid && form.get('identificador')?.touched" class="p-error">
                    Identificador é obrigatório.
                </small>
            </div>
        </form>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" icon="pi pi-arrow-left" (click)="displayModal = false" label="Voltar"
            class="p-button-raised p-button-warning mr-2">
        </button>
        <button *ngIf="loading == false" pButton pRipple type="button" icon="pi pi-check" (click)="save()"
            label="Salvar" class="p-button-raised p-button-success"></button>
        <p-progressSpinner *ngIf="loading" [style]="{width: '50px', height: '50px'}" styleClass="custom-spinner"
            strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"></p-progressSpinner>
    </ng-template>
</p-dialog>

<!-- Modal de confirmação de exclusão quando há estação vinculada -->
<p-dialog header="Excluir transmissor?" [(visible)]="modalExcluirComEstacao" [modal]="true"
    [style]="{width: '500px'}" [draggable]="false" [resizable]="false" [closable]="true"
    [dismissableMask]="false" (onHide)="fecharModalExcluirComEstacao()">
    <div class="p-fluid" *ngIf="sensorParaExcluir && estacaoRelacionada">
        <p class="mb-3">
            Este transmissor está vinculado à estação <strong>{{ estacaoRelacionada.nome }}</strong>.
            Ao excluir, o vínculo será removido (soft delete).
        </p>
        <p class="mb-3">
            Para evitar exclusões acidentais, digite <strong>Excluir transmissor</strong> para confirmar.
        </p>
        <div class="field">
            <label for="input-excluir-transmissor">Confirmação</label>
            <input id="input-excluir-transmissor" type="text" pInputText
                [(ngModel)]="inputExcluirTransmissor"
                placeholder="Excluir transmissor"
                [class.ng-invalid]="inputExcluirTransmissor && inputExcluirTransmissor !== textoConfirmacaoExclusao" />
        </div>
    </div>
    <ng-template pTemplate="footer">
        <button pButton pRipple type="button" label="Cancelar" icon="pi pi-times"
            class="p-button-text" (click)="fecharModalExcluirComEstacao()"></button>
        <button pButton pRipple type="button" label="Excluir" icon="pi pi-trash"
            class="p-button-danger"
            [disabled]="inputExcluirTransmissor !== textoConfirmacaoExclusao"
            (click)="executarExclusaoComEstacao()"></button>
    </ng-template>
</p-dialog>
